// Gradually changes a value towards a desired goal over time.
/*
public static float SmoothDamp(float current, float target, ref float currentVelocity, float smoothTime, [uei.DefaultValue("Mathf.Infinity")]  float maxSpeed, [uei.DefaultValue("Time.deltaTime")]  float deltaTime)
{
    // Based on Game Programming Gems 4 Chapter 1.10
    smoothTime = Mathf.Max(0.0001F, smoothTime);
    float omega = 2F / smoothTime;

    float x = omega * deltaTime;
    float exp = 1F / (1F + x + 0.48F * x * x + 0.235F * x * x * x);
    float change = current - target;
    float originalTo = target;

    // Clamp maximum speed
    float maxChange = maxSpeed * smoothTime;
    change = Mathf.Clamp(change, -maxChange, maxChange);
    target = current - change;

    float temp = (currentVelocity + omega * change) * deltaTime;
    currentVelocity = (currentVelocity - omega * temp) * exp;
    float output = target + (change + temp) * exp;

    // Prevent overshooting
    if (originalTo - current > 0.0F == output > originalTo)
    {
        output = originalTo;
        currentVelocity = (output - originalTo) / deltaTime;
    }

    return output;
}*/

export class SmoothDampData {
    currentVelocity = 0;
    constructor() {
        this.currentVelocity = 0;
    }
}

export function SmoothDamp(current, target, dampData, smoothTime, maxSpeed, deltaTime)
{
    // Based on Game Programming Gems 4 Chapter 1.10
    smoothTime = Math.max(0.0001, smoothTime);
    let omega = 2.0 / smoothTime;

    let x = omega * deltaTime;
    let exp = 1.0 / (1.0 + x + 0.48 * x * x + 0.235 * x * x * x);
    let change = current - target;
    let originalTo = target;

    // Clamp maximum speed
    let maxChange = maxSpeed * smoothTime;
    //change = Math.clamp(change, -maxChange, maxChange);
    change = Math.max(change, -maxChange);
    change = Math.min(change, maxChange);
    target = current - change;

    let temp = (dampData.currentVelocity + omega * change) * deltaTime;
    dampData.currentVelocity = (dampData.currentVelocity - omega * temp) * exp;
    let output = target + (change + temp) * exp;

    // Prevent overshooting
    if (originalTo - current > 0.0 == output > originalTo)
    {
        output = originalTo;
        dampData.currentVelocity = (output - originalTo) / deltaTime;
    }

    return output;
}